import React from 'react'
import CommonTasksContext from '../../../contexts/CommonTasksContext'
import { ResponseDisplay } from "../responsedisplay/ResponseDisplay"
import StatusContext from '../../../contexts/StatusContext';
import { useLocation } from 'react-router-dom'
import { useEffect} from "react";
import { NavBarCommon } from '../../main/navbarcommon/NavBarCommon'
import { PromptWithIcon } from '../promptwithicon/PromptWithIcon';
import { AlertDialog } from '../alertdialog/AlertDialog'
import { PushButton } from '../pushbutton/PushButton'
import { AvailableCredits } from '../availablecredits/AvailableCredits'
import { DialogCustomPrompt } from './DialogCustomPrompt';
import Stack from '@mui/material/Stack'
import { DialogDisplayCustomPrompts } from './DialogDisplayCustomPrompts';
import "./commontasks.css"
import { WaitonResponse } from '../waitonresponse/WaitonResponse';
import AuthContext from "../../../contexts/AuthContext";
import AIButton from "../aibutton/AIButton"
import { DialogSelectModels } from '../aibutton/DialogSelectModels';
//import GlobalSearchContext from '../../../contexts/GlobalSearchContext'
//import FileUploader from '../FileUploader/FileUploader';
//import LanguageIcon from '@mui/icons-material/Language';
//import {CustomTooltip} from  '../customtooltip/CustomTooltip'

export const CommonTasks = () => {

  const {
    checkCurrentUser,
    //currentUser,
  } = React.useContext(AuthContext);

  /*
  const {
    onGlobalSearch,
  } = React.useContext(GlobalSearchContext);
  */

  
  const handleShowShortcuts = async () => {

    if (checkCurrentUser() === false)
      {
          setStatus(changeLanguage('status', 'pleaselogin'))
          return;
      }
    const allprompts = await fetchPrompts()
  
    if (allprompts.status !== 200)
    {
        setStatus("Not able to get custom prompts.")
        return
    }
   
    setDisplayCustomPromptsDialog(true)
   
  }


  const alertYes = () => {
    onClearChat()
    closeDialogBox()
  }

  const alertCancel = () => {
    closeDialogBox()
  }

  const alertYesSave = () => {
    onSaveCustomPrompts()
    closeSaveDialogBox()
    setShowCustomPromptDialog(false);
  }

  const alertCancelSave = () => {
    closeSaveDialogBox()
  }

  const closeSaveDialogBox = () => {
    setShowSaveDialog(false)
  }

  const alertYesDelete = () => {
    onDeleteCustomPrompt()
    closeDeleteDialogBox()
  }

  const alertCancelDelete = () => {
    closeDeleteDialogBox()
  }

  const closeDeleteDialogBox = () => {
    setShowDeleteDialog(false)
  }

  let {
    promptsandresponses,
    confirmDelete,
    onDeletePrompt,
    changeConfirmDelete,
    onClearChat,
    displaySample,
    chatPrompt,
    setChatPrompt,
    onSubmitChat,
    status,
    setShowDeleteDialog,
    showdeletedialog,
    setShowSaveDialog,
    showsavedialog,
    dialogboxtext,
    setShowCustomPromptDialog,
    onSaveCustomPrompts,
    onDeleteCustomPrompt,
    onResubmitChat,
    setDisplayCustomPromptsDialog,
    fetchPrompts,
    setStatus,
  } = React.useContext(CommonTasksContext);

  let {
    isMobile, 
    scrollRef,
    changeLanguage,
    openDialog,
    openDialogBox,
    closeDialogBox,
    onCopy,
    focusRef,
    getAIProvider,
    getAIName,
    onClickAIButton,
  } = React.useContext(StatusContext);

  var sample = '';
  const location = useLocation()
  if (location.state !== null)
    sample = location.state.sample

  useEffect(() => {
    const setSample = () => {

      if (sample) {
        displaySample(sample)
        
        location.state.sample = '';
      }
    }
    setSample();

  }, [sample, displaySample, location.state])



  return (

    <div className="homeContainer">
          {
              isMobile() &&
               <AIButton pane={0} provider = {getAIProvider()} model = {getAIName()} onClick = {()=>{onClickAIButton(0)}}/>
            }
  
          <NavBarCommon title={changeLanguage('common', 'navbartitle')} />

        
       
        <div className="response-markdown" ref={scrollRef}>
            {
              Array.isArray(promptsandresponses) &&
              promptsandresponses.map((item) => (
                <ResponseDisplay key={item.id} 
                    displayprompt={item} 
                    displayicons={confirmDelete[promptsandresponses.indexOf(item)].state}
                    changeConfirmDelete={changeConfirmDelete} 
                    onDeletePrompt={onDeletePrompt} 
                    onResubmitQuestion={onResubmitChat} 
                    onCopy={onCopy}
                    />
              ))
            }
        </div>
        {
          (!status) &&
            <WaitonResponse />
        }
        <hr className = 'separator'></hr>
        
        <PromptWithIcon prompt={chatPrompt} setPrompt={setChatPrompt} onSubmit={onSubmitChat} placeholdertext={changeLanguage('common', 'promptplaceholder')}/>
       
        {
          (status) && <label className='statusLabel'>{status}</label>
        }
        
        <div ref = {focusRef} className="mainButtons">
         
          <Stack direction = "row" spacing={2}>
            {
              !isMobile() &&
                <AIButton pane={0} provider = {getAIProvider()} model = {getAIName()} onClick = {()=>{onClickAIButton(0)}}/>
            }
          
             {/*
              currentUser === 'dsrdjevic@yahoo.com' && 
                <CustomTooltip title={changeLanguage('status', 'globalsearch')}>
                  <span>
                    <LanguageIcon sx={{ fontSize: 30, color:'maroon', padding:'3px'}} onClick={()=> { onGlobalSearch(chatPrompt)}}/>
                    </span>
                  </CustomTooltip>
            */}

            <PushButton onClick={handleShowShortcuts} label={changeLanguage('common', 'shortcuts')} />
            <PushButton onClick={openDialogBox} label={changeLanguage('common', 'clearall')} />

           
        
          </Stack>
          <AvailableCredits />
         
        
        </div>
        <label style={{ width:  isMobile() ? '100%' : '50%' }}>{changeLanguage("common", "note")}</label>
      
        <AlertDialog alertYes={alertYes} alertCancel={alertCancel} openDialog={openDialog} closeDialog={closeDialogBox} prompt={changeLanguage('dialog', 'cleardata')} />
        <AlertDialog alertYes={alertYesDelete} alertCancel={alertCancelDelete} openDialog={showdeletedialog} closeDialog={closeDeleteDialogBox} prompt={dialogboxtext} />
        <AlertDialog alertYes={alertYesSave} alertCancel={alertCancelSave} openDialog={showsavedialog} closeDialog={closeSaveDialogBox} prompt={changeLanguage('common', 'dialogupdateprompt')} />
  
      <DialogCustomPrompt />
      <DialogDisplayCustomPrompts />
      <DialogSelectModels />
    </div>

  )
}


